import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
    const { t } = useTranslation();
  return (
            <div className="not-found-page">
        <div className="container text-center">
                <h1>404</h1>
                <h2>{t('notFoundTitle')}</h2>
                <p>{t('notFoundText')}</p>
                <Link to="/" className="cta-button">{t('notFoundButton')}</Link>
        </div>
        </div>
  );
};

export default NotFoundPage;

